import { render, staticRenderFns } from "./user-agent.vue?vue&type=template&id=06d52dd4&"
import script from "./user-agent.vue?vue&type=script&lang=ts&"
export * from "./user-agent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports